<template>
  <div>
    <van-tabbar v-model="active" active-color="#34A7F4">
    <van-tabbar-item to="/prolist">
      <span>产品列表</span>
      <template #icon="props">
        <img :src="props.active ? require('../assets/img/produce/list1.png') : require('../assets/img/produce/list.png')" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item  to="/myorders">
      <span>我的订单</span>
      <template #icon="props">
        <img :src="props.active ? require('../assets/img/produce/order1.png'):require('../assets/img/produce/order.png')" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
  </div>
</template>

<script>
export default {
  
  data(){
    return{
      active: 0,
    }
  },
  watch:{
    $route(){
      console.log(this.$route)
      if(this.$route.path=='/myorders'){
        this.active=1
      }else{
        this.active=0
      }
    }
  },
  mounted(){
    if(this.$route.path=='/myorders'){
        this.active=1
      }else{
        this.active=0
      }
  }
  
};
</script>

<style scoped lang="less">
.footer {
  border-top: 1px solid #ebebeb;
  height: 50px;
  position: fixed;
  bottom: 0;
  width: 100%;
  bottom: 0;
  left: 0;
  .text {
    color: #797d82;
  }
  .active .text {
    color: @orange;
  }
  .tab_img{
    width: 28px;
    height: 28px;
  }
}
</style>
